<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-input
                            style="width: 420px"
                            placeholder="输入玩家昵称，多个用' , '分隔"
                            v-model="searchVal">
                        <template slot="prepend">玩家昵称</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            format="yyyy-MM-dd HH:mm"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="-"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>

        <div class="common-table">
            <el-table v-loading="loading" :data="userRecord.data" height="100%">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="用户昵称" align="center" prop="nickName"/>
                <el-table-column label="次数" align="center" prop="cishu"/>
                <el-table-column label="jackpot击中值" align="center" prop="sum"/>
            </el-table>
        </div>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                date: null,
                searchVal: '',
            }
        },
        computed: {
            ...mapState('jackpot', ['userRecord']),
        },
        created() {
            // 搜索后二次进入页面时就会有原搜索
            this.searchVal = this.userRecord.nickNames;
            this.date = this.userRecord.date;
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('jackpot', ['getUserRecord']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                if (!this.searchVal) {
                    this.$message.error('请输入玩家昵称');
                    return false
                }
                return true
            },
            getList(obj = {}) {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    nickNames: this.searchVal,
                    date: this.date,
                };
                Object.assign(params, obj);
                this.getUserRecord(params).then(() => {
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/jp/user/jpRecordFile/export',
                    info: [
                        {name: 'nickNames', value: this.searchVal},
                        {name: 'startTime', value: this.date ? this.date[0] : ''},
                        {name: 'endTime', value: this.date ? this.date[1] : ''},
                    ]
                });
            }
        }
    }
</script>